<template>
    <div>
        <el-button
            v-if="hasDuplicates"
            type="warning"
            size="small"
            circle
            @click="openDrawer"
        >
            <ComTooltip content="Päällekkäisiä tilatunnuksia">
                <el-icon>
                    <Warning/>
                </el-icon>
            </ComTooltip>
        </el-button>

        <el-drawer
            v-model="drawerVisible"
            title="Päällekkäiset tilatunnukset"
            direction="rtl"
            size="50%"
            :append-to-body="true"
            v-if="hasDuplicates"
        >
            <el-table v-if="!error" :data="duplicates?.duplicates" stripe>
                <el-table-column prop="tilatunnus" label="Tilatunnus" width="150">
                    <template #default="scope">
                        <el-tag type="primary">{{ scope.row.tilatunnus }}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="count" label="Määrä" width="100">
                    <template #default="scope">
                        {{ scope.row.count }}
                    </template>
                </el-table-column>

                <el-table-column label="Tila ID:t" min-width="200">
                    <template #default="scope">
                        <el-space wrap>
                            <el-tag
                                v-for="tilaId in scope.row.tilaIds"
                                :key="tilaId"
                                type="info"
                                size="small"
                            >
                                {{ tilaId }}
                            </el-tag>
                        </el-space>
                    </template>
                </el-table-column>
            </el-table>
        </el-drawer>
    </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useTilatunnusDuplicates } from '@/methods/tilatunnusDuplicatesComposables'
import { ElMessage } from 'element-plus'
import { Warning } from '@element-plus/icons-vue'
import ComTooltip from '@/components/common/ComTooltip.vue'

interface Props {
    hankeId: number
}

const props = defineProps<Props>()
const hankeId = computed(() => props.hankeId)
const drawerVisible = ref(false)

const { duplicates, hasDuplicates, loading, error } = useTilatunnusDuplicates(hankeId)

const openDrawer = () => {
    drawerVisible.value = true
}

watch(error, (value) => {
    if (value) {
        ElMessage.error('Virhe duplikaattien haussa!')
    }
})

</script>

<script lang="ts">
export default {
    name: 'ComDuplicatesWarning',
    inheritAttrs: false
}
</script>

<style scoped>
.error-message {
    margin: 20px 0;
}
</style>